var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0664 8.25V6.06641H9.93359V8.25H12.0664ZM12.0664 16.9336V10.4336H9.93359V16.9336H12.0664ZM3.33203 3.88281C5.46484 1.75 8.02083 0.683594 11 0.683594C13.9792 0.683594 16.5182 1.75 18.6172 3.88281C20.75 5.98177 21.8164 8.52083 21.8164 11.5C21.8164 14.4792 20.75 17.0352 18.6172 19.168C16.5182 21.2669 13.9792 22.3164 11 22.3164C8.02083 22.3164 5.46484 21.2669 3.33203 19.168C1.23307 17.0352 0.183594 14.4792 0.183594 11.5C0.183594 8.52083 1.23307 5.98177 3.33203 3.88281Z",
    fill: "#3D4259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7d23f57ce8164a61f6887988ce785a0d.svg";
export { ForwardRef as ReactComponent };